import React, { useState } from 'react';
import { Modal } from 'src/components/new/modal/Modal';
import { ModalTitle } from 'src/components/new/modal/ModalTitle';
import { ModalContent } from 'src/components/new/modal/ModalContent';
import { ModalFooter } from 'src/components/new/modal/ModalFooter';
import { TextField } from 'src/components/new/inputs/TextField';
import { AppDispatch, RootState } from 'src/store/store';
import { useDispatch, useSelector } from 'react-redux';
import { handleDescriptionNameChange } from 'src/features/company/companySlice';

interface AddDescriptionProps {
  open: boolean;
  mode: 'Edit' | 'Add';
  onClose: () => void;
  onSuccess: (description: string) => void;
}

const AddDescription: React.FC<AddDescriptionProps> = ({ open, onClose, onSuccess, mode }) => {
  const dispatch: AppDispatch = useDispatch();

  const [descriptionError, setDescriptionError] = useState('');

  const descriptionName = useSelector((state: RootState) => state.company.descriptionForm.value);
  const descriptions = useSelector((state: RootState) => state.company.documentDescriptions) || [];

  const handleClose = () => {
    setDescriptionError('');
    onClose();
  };

  const handleSubmit = () => {
    let newError = '';
    if (descriptionName === '') {
      newError = 'Description is required';
    }
    if (descriptions.map((description) => description.text).includes(descriptionName)) {
      newError = 'Description already exists';
    }

    setDescriptionError(newError);

    if (!newError) {
      onSuccess(descriptionName);
      handleClose();
    }
  };

  const handleChange = (e: any) => {
    dispatch(handleDescriptionNameChange(e.target.value));
  };

  return (
    <>
      <Modal open={open} onClose={handleClose} sx={{ minWidth: '27.5rem' }}>
        <ModalTitle small onClose={handleClose}>
          {mode} Description
        </ModalTitle>
        <ModalContent small>
          <TextField
            required
            value={descriptionName}
            name="description"
            id="description"
            onChange={handleChange}
            error={descriptionError}
            label="Document Description"
          />
        </ModalContent>
        <ModalFooter onSubmit={handleSubmit} submitText="Save" />
      </Modal>
    </>
  );
};

export default AddDescription;
